import {
  addDays,
  format,
  startOfDay,
  startOfMonth,
  startOfYear,
  subMonths,
} from 'date-fns';

import { formatDate } from 'helpers/date';

import { TimeFrameType } from '../../../../types';

export const toSentenceCase = (string: string) =>
  `${string.substring(0, 1).toUpperCase()}${string.substring(1).toLowerCase()}`;

export const getLastThreeMonthsText = (date: Date) => {
  const lastThreeMonths = [
    subMonths(date, 3),
    subMonths(date, 2),
    subMonths(date, 1),
  ];

  return toSentenceCase(
    lastThreeMonths.map((dateItem) => formatDate(dateItem, 'LLLL')).join(', '),
  );
};

export const getLastMonthText = (date: Date) => {
  return toSentenceCase(formatDate(subMonths(date, 1), 'LLLL'));
};

export const getCurrentMonthText = (now: Date) => {
  return toSentenceCase(formatDate(now, 'LLLL'));
};

export const formatTimeFrameDate = (date: Date) => format(date, 'yyyy-MM-dd');

export const getTimeFrameDates = (timeframeType: TimeFrameType) => {
  const now = new Date();

  switch (timeframeType) {
    case TimeFrameType.CURRENT_MONTH:
      return {
        // Add 1 day to be able to do `date < endDate`
        endDate: formatTimeFrameDate(addDays(now, 1)),
        startDate: formatTimeFrameDate(startOfMonth(now)),
      };
    case TimeFrameType.LAST_MONTH:
      return {
        endDate: formatTimeFrameDate(startOfMonth(now)),
        startDate: formatTimeFrameDate(startOfMonth(subMonths(now, 1))),
      };
    case TimeFrameType.LAST_3_MONTHS:
      return {
        endDate: formatTimeFrameDate(startOfMonth(now)),
        startDate: formatTimeFrameDate(startOfMonth(subMonths(now, 3))),
      };
    case TimeFrameType.CURRENT_YEAR:
      return {
        // Add 1 day to be able to do `date < endDate`
        endDate: formatTimeFrameDate(addDays(now, 1)),
        startDate: formatTimeFrameDate(startOfYear(now)),
      };
    case TimeFrameType.CUSTOM_TIMEFRAME:
    default:
      return {
        // Don't add 1 day here as it will be displayed to the user
        endDate: formatTimeFrameDate(now),
        startDate: formatTimeFrameDate(startOfDay(subMonths(now, 3))),
      };
  }
};
